export const brl = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const dateTime = (iso) =>
  new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export const STATUS = {
  pendente: { label: "Pendente", cls: "bg-primo-500/15 text-primo-400 border-primo-500/30" },
  aguardando_comprovante: { label: "Aguardando comprovante", cls: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30" },
  preparando: { label: "Preparando", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  saiu: { label: "Saiu p/ entrega", cls: "bg-primo-500/20 text-primo-300 border-primo-400/40" },
  concluido: { label: "Concluído", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  cancelado: { label: "Cancelado", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
};

export const PAYMENT = { dinheiro: "Dinheiro", pix: "Pix", cartao: "Cartão (maquininha)" };
